<template>
  <application-layout>
    <v-container>
      <h1>Document Manager</h1>
      <v-layout class="mt-5">
        <v-flex>
          <div>Please select a location to view E-Sign documents:</div>
          <v-select
            data-testid="doc-facility-dropdown-menu"
            :items="searchOptions"
            class="doc-facility-dropdown-menu my-3"
            outlined
            label="Select location..."
            item-text="location_code"
            item-value="location_code"
            v-model=locationCode
            @change="getSignatureRequests"
            hide-details
          />
        </v-flex>
      </v-layout>
      <transition name="fade-transition" mode="out-in">
        <v-progress-linear
          v-if="loading"
          :size="70"
          :width="7"
          indeterminate
          class="mb-3"
        />
        <div v-else-if="showTabs" key="show-tabs">
          <v-tabs
            grow
            icons-and-text
            v-model="tab"
          >
            <v-tab
              data-testid="signed-documents-tab"
              class="signed-documents-tab"
            >
              <span class="text-subtitle-2 mt-2 mb-0">Signed Documents</span>
              <v-icon>thumb_up</v-icon>
            </v-tab>
            <v-tab
              data-testid="unsigned-documents-tab"
              class="unsigned-documents-tab"
            >
              <span class="text-subtitle-2 mt-2 mb-0">Unsigned Documents</span>
              <v-icon>post_add</v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items
            class="mt-3"
            v-model="tab"
            touchless
          >
            <v-tab-item eager>
              <document-table
                :locationCode="locationCode"
                :documentsType="documentsType"
                :pagination="pagination"
                :tableLoading="tableLoading"
                @searchDocuments="searchDocuments"
                @updatePagination="updatePagination($event)"
              />
            </v-tab-item>
            <v-tab-item eager>
              <document-table
                :locationCode="locationCode"
                :documentsType="documentsType"
                :pagination="pagination"
                :tableLoading="tableLoading"
                @searchDocuments="searchDocuments"
                @updatePagination="updatePagination($event)"
              />
            </v-tab-item>
          </v-tabs-items>
        </div>
      </transition>
    </v-container>
  </application-layout>
</template>

<script>
import ApplicationLayout from "../../layouts/ApplicationLayout";
import DocumentTable from "@/views/document-manager/components/DocumentTable.vue";
import { mapState } from "vuex";

export default {
  data() {
    return {
      locationCode: null,
      tabsLoading: false,
      tableLoading: false,
      pagination: {
        page: 1,
        rowsPerPage: 25
      },
      tab: 0
    };
  },
  methods: {
    async getDocuments(payload) {
      try {
        await this.$store.dispatch("getEsignSignatureRequests", payload);
      } finally {
        this.toggleViewLoading(false);
      }
    },
    toggleViewLoading(loadState) {
      this.tabsLoading = loadState;
      this.tableLoading = loadState;
    },
    searchDocuments() {
      this.tabsLoading = true;
      this.getDocuments(this.documentRequestPayload);
    },
    updatePagination(pagination) {
      const shouldUpdate = (Object.values(pagination).join("") !== Object.values(this.pagination).join(""));
      if (shouldUpdate) {
        this.pagination = pagination;
        this.tableLoading = true;
        this.getDocuments(this.documentRequestPayload);
      }
    },
    getSignatureRequests() {
      this.$store.dispatch("clearEsignSearchTerms");
      this.tabsLoading = true;
      const payload = this.documentRequestPayload;
      payload.load_new_facility = true;
      this.getDocuments(payload);
    }
  },
  computed: {
    ...mapState({
      facilities: state => state.facilities.allFacilities,
      signedDocuments: state => state.documentManager.signedDocuments,
      signedSearchTerm: state => state.documentManager.signedSearchTerm,
      unsignedDocuments: state => state.documentManager.unsignedDocuments,
      unsignedSearchTerm: state => state.documentManager.unsignedSearchTerm
    }),
    searchOptions() {
      const locationNames = this.facilities.map(facility => facility.location_code);
      const allOptions = ["All", ...locationNames];
      if (process.env.VUE_APP_HIDE_LTRAIN === "true") {
        return allOptions.filter(facilityName => facilityName !== "LTRAIN");
      }
      return allOptions;
    },
    documentsType() {
      return this.tab === 0 ? "signed" : "unsigned";
    },
    loading() {
      return this.tabsLoading && this.locationCode;
    },
    showTabs() {
      return !this.tabsLoading && this.locationCode;
    },
    query() {
      let query = "test_mode:false";
      switch (this.documentsType) {
        case "signed":
          query += " AND complete:true";
          break;
        case "unsigned":
          query += " AND complete:false";
      }
      const searchTerm = this.tab === 0 ? this.signedSearchTerm : this.unsignedSearchTerm;
      if (searchTerm) {
        query += ` AND to:${searchTerm}`;
      }
      return query;
    },
    documentRequestPayload() {
      return {
        location_code: this.locationCode !== "All" ? this.locationCode : null,
        query: this.query,
        page: this.pagination.page,
        per_page: this.pagination.per_page ? this.pagination.per_page : 25,
        load_new_facility: false
      };
    }
  },
  watch: {
    /* istanbul ignore next */
    documentsType(documentType) {
      if (documentType === "signed" && !this.signedDocuments.length) {
        this.tableLoading = true;
        this.getDocuments(this.documentRequestPayload);
      }
      if (documentType === "unsigned" && !this.unsignedDocuments.length) {
        this.tableLoading = true;
        this.getDocuments(this.documentRequestPayload);
      }
    }
  },
  components: {
    ApplicationLayout,
    DocumentTable
  }
};
</script>

<style>
  .facility-dropdown-box {
    max-width: 15rem;
  }
</style>
